<script setup lang="ts">
import { useClipboard, useTimeoutFn } from '@vueuse/core'
import type { Article } from '~/models/Strapi'

interface Props {
  article: Article
}

const props = defineProps<Props>()
const emit = defineEmits(['modalOpen'])
const token = useCookie('token', { path: '/' })
const downloadFile = ref()
const downloadClicked = ref(false)

async function getFile(response: any) {
  downloadClicked.value = true
  const { data } = await useStrapiAssetAPI<any>(`/${response.hash}${response.ext}`, {
    key: 'download_file',
    responseType: 'blob',
  })
  if (data.value && process.client) {
    downloadFile.value = data.value
    clickDownload(data.value, response)
  }
}

function clickDownload(blobData: Blob, response: any) {
  const url = window.URL.createObjectURL(new Blob([blobData], { type: 'application/pdf' }))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', response.name)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
</script>

<template>
  <div class="bg-white rounded-xl p-6 pb-10">
    <div class="flex items-center mb-4">
      <p class="text-lg font-bold">
        File content
      </p>
      <div class="ml-auto text-xs flex items-center py-1 px-4 bg-[#EFF6FF] rounded-full uppercase">
        <Icon name="material-symbols:attach-file" class="w-3.5 h-3.5 mr-2" />{{ props.article?.file_attachment?.ext.slice(1) }}
      </div>
    </div>
    <p class="text-base">
      Problem statement template content and all of the tips can be downloaded here.
    </p>
    <p v-if="downloadClicked" class="text-sm text-gray-500 mt-4">
      Download should starting soon... <br>
      Nothing happen? Click retry below.
    </p>
    <BaseAtomsButton v-if="!downloadClicked" size="sm" classes="flex items-center font-semibold w-full mt-4 text-xs" @click="token ? getFile(props.article.file_attachment) : emit('modalOpen')">
      Free Download
      <Icon name="material-symbols:file-download" class="w-5 h-5 ml-2" />
    </BaseAtomsButton>
    <BaseAtomsButton v-if="downloadClicked" size="sm" outline classes="flex items-center font-semibold w-full mt-4 text-xs" @click="token ? getFile(props.article.file_attachment) : emit('modalOpen')">
      Retry
      <Icon name="material-symbols:file-download" class="h-5 w-5 ml-2" />
    </BaseAtomsButton>
  </div>
</template>

<style scoped>
.w-fit {
  width: fit-content;
}
body{
  overflow: scroll;
}
</style>
